export type EventLocation = {
    id: number;
    name: string;
};

const types = {
    ACCESS_DESTROY_FAILED: "EVENT/ACCESS_DESTROY_FAILED",
    ACCESS_DESTROY_REQUEST: "EVENT/ACCESS_DESTROY_REQUEST",
    ACCESS_DESTROY_SUCCESS: "EVENT/ACCESS_DESTROY_SUCCESS",

    ACCESS_FETCH_FAILED: "EVENT/ACCESS_FETCH_FAILED",
    ACCESS_FETCH_REQUEST: "EVENT/ACCESS_FETCH_REQUEST",
    ACCESS_FETCH_SUCCESS: "EVENT/ACCESS_FETCH_SUCCESS",

    ACCESS_UPDATE_FAILED: "EVENT/ACCESS_UPDATE_FAILED",
    ACCESS_UPDATE_REQUEST: "EVENT/ACCESS_UPDATE_REQUEST",
    ACCESS_UPDATE_SUCCESS: "EVENT/ACCESS_UPDATE_SUCCESS",

    LOCATIONS_FETCH_FAILED: "EVENT/LOCATIONS_FETCH_FAILED",
    LOCATIONS_FETCH_REQUEST: "EVENT/LOCATIONS_FETCH_REQUEST",
    LOCATIONS_FETCH_SUCCESS: "EVENT/LOCATIONS_FETCH_SUCCESS",

    LOCATIONS_ROLES_FAILED: "EVENT/LOCATIONS_ROLES_FAILED",
    LOCATIONS_ROLES_REQUEST: "EVENT/LOCATIONS_ROLES_REQUEST",
    LOCATIONS_ROLES_SUCCESS: "EVENT/LOCATIONS_ROLES_SUCCESS",
};

export default types;
